import { CustomButton, SearchBar } from "components/form";
import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CustomModal, PopupModal } from "components/modals/ModalBox";
import { dateFormatWithTime } from "utils/dateFormat";
import Pagination from "react-js-pagination";

import useFullPageLoader from "common/UseFullPageLoader";
import useButtonLoader from "common/UseButtonLoader";
import { FaRegEdit, FaRegTrashAlt } from "react-icons/fa";

import useDebounce from "common/UseDebounce";
import { getLocalStorage, setLocalStorage } from "config/config";
import { toastMessage } from "utils/toastMessage";
import NotFound from "common/NotFound";
import { toast } from "sonner";
import { deleteFaqApi, faqView, getFaqApi } from "services/faq";
import { AddFAQModel } from "./AddFaq";
import { EditFAQModel } from "./EditFaq";
import DescriptionModal from "common/DescriptionModal";
import { charLimit } from "utils/formValidator";
const FAQManagement = () => {
  const [deleteModal, setDeleteModal] = useState(false);
  const [faqList, setFaqList] = useState([]);
  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [types, setType] = useState("student");

  const [search, setSearch] = useState(
    getLocalStorage("faqList", "search") || ""
  );
  const debouncedValue = useDebounce(search, 300);
  const [fieldName, setFieldName] = useState("");
  const [direaction, setDirection] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const [selected, setSelected] = useState({});
  const [total, setTotal] = useState(null);
  const [buttonLoaders, setButtonLoaders] = useButtonLoader("Yes");
  const activePage = +searchParams.get("page") || 1;
  const limit = +searchParams.get("limit") || 10;
  const [inputData, setInputData] = useState({});
  const [descriptionModal, setDescriptionModal] = useState(false);
  const [description, setDescription] = useState("");
  const [loader, onShow, onHide] = useFullPageLoader();

  // sort
  const toggleSortOrder = () => {
    setDirection(direaction === "ASC" ? "DESC" : "ASC");
  };
  const handleSort = (field) => {
    if (field === fieldName) {
      toggleSortOrder();
    } else {
      setFieldName(field);
      setDirection("ASC");
    }
  };
  // delete handler
  const deleteHandler = (id) => {
    setSelected({ id, action: "delete" });
    setDeleteModal(true);
  };
  // change delete handler
  const changeDeleteHandler = async () => {
    try {
      setButtonLoaders(true);
      const res = await deleteFaqApi(selected.id);
      if (res.data.status === 200) {
        toastMessage(res.data.message, "success", "delete");
        setDeleteModal(false);
        faqListHandler();
      } else {
        toastMessage(res.data.message, "error", "delete");
      }
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setButtonLoaders(false);
    }
  };
  /*************Reset Filter Handler*********************/
  const resetFilterHandler = () => {
    searchParams.delete("page");
    setSearchParams(searchParams);
  };
  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    searchParams.set("page", event);
    setSearchParams(searchParams);
  };
  // faq list handler
  const faqListHandler = async (
    page = activePage,
    limit = "10",
    search = debouncedValue,
    sortField = fieldName || "createdAt",
    sortDirection = direaction
  ) => {
    try {
      onShow();
      const res = await getFaqApi({
        page,
        limit,
        search,
        sortField,
        sortDirection,
      });
      if (res?.data?.status === 200) {
        setTotal(res.data.data.total);
        setFaqList(res.data?.data?.faq);
        onHide();
      } else {
        toastMessage(res?.data?.message, "error", "faqList");
      }
    } catch (e) {
      onHide();
      toast.error(e.message);
    }
  };
  useEffect(() => {
    if (Number(activePage) === 1) {
      searchParams.delete("page");
      setSearchParams(searchParams);
    }
    faqListHandler();
  }, [searchParams, debouncedValue, fieldName, direaction, types]);

  useEffect(() => {
    if (search) {
      searchParams.delete("page");
    }
  }, []);

  useEffect(() => {
    setLocalStorage("faqList", "search", search);
  }, [search]);
  return (
    <>
      <div className="student_management">
        <div className="card mb-2">
          <div className="dashboard_title has_child">
            <h3>FAQ Management</h3>
            <CustomButton
              type="button"
              className="button"
              onClick={() => {
                setAddModal(true);
              }}
            >
              Add FAQ
            </CustomButton>
          </div>
       
        <div className="button_section_wrap">
          <div className="search_wrapper">
            <SearchBar
              placeholder={"Search..."}
              onChange={(e) => {
                setSearch(e.target.value);
                searchParams.delete("page");
                setSearchParams(searchParams);
              }}
              value={search}
            />
          </div>
        </div>
        </div>
        <div className="card">
          <div className="card-body">
            <div className="table_wrap ">
              <table className="table custom_table">
                <thead>
                  <tr>
                    <th className="nowrap">S.no</th>
                    <th className="nowrap">Question</th>
                    <th className="nowrap">Answer</th>
                    <th className="nowrap">Created On</th>
                    <th className="nowrap text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loader}
                  {faqList && faqList.length > 0 ? (
                    faqList?.map((data, index) => {
                      return (
                        <tr key={++index}>
                          <td className="nowrap">{index + 1}</td>
                          <td className="nowrap">{data?.title}</td>
                          <td className="nowrap">
                            {data?.description.length > 50 ? (
                              <div className="d-flex wrap_td_span">
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: charLimit(data?.description, 30),
                                  }}
                                ></p>
                                &nbsp;
                                <span
                                  onClick={() => {
                                    setDescriptionModal(true);
                                    setDescription(
                                      <p
                                        dangerouslySetInnerHTML={{
                                          __html: data?.description,
                                        }}
                                      ></p>
                                    );
                                  }}
                                >
                                  <b>Read More</b>
                                </span>
                              </div>
                            ) : (
                              <p
                                dangerouslySetInnerHTML={{
                                  __html: data?.description,
                                }}
                              ></p>
                            )}
                          </td>
                          <td>{dateFormatWithTime(data?.createdAt)}</td>
                          <td>
                            {" "}
                            <div className="icon_wrap">
                              <Link
                                onClick={() => {
                                  setEditModal(true);
                                  setInputData(data);
                                }}
                                className="icon_button"
                              >
                                <FaRegEdit />
                              </Link>
                              <Link
                                to=""
                                className="icon_button"
                                onClick={(e) => {
                                  e.preventDefault();
                                  deleteHandler(data?._id);
                                }}
                              >
                                <FaRegTrashAlt />
                              </Link>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <NotFound
                      cols={7}
                      msg={"FAQ data not found"}
                      onHide={onHide}
                    />
                  )}
                </tbody>
              </table>
            </div>
            {total > limit && (
              <div className="pagination-wrapper">
                <div className="Pagination">
                  <Pagination
                    activePage={activePage}
                    previousLabel={"previous"}
                    nextLabel={"next"}
                    itemsCountPerPage={limit}
                    totalItemsCount={total}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    hideDisabled={true}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* Delete FAQ Modal */}
      <PopupModal
        show={deleteModal}
        handleClose={() => {
          setSelected({});
          setDeleteModal(false);
        }}
        content="Are you sure you want to delete this Faq?"
        title="Delete Faq"
        onShow={changeDeleteHandler}
        buttonLoader={buttonLoaders}
      />
      <AddFAQModel
        setAddModal={setAddModal}
        addModal={addModal}
        types={types}
        faqListHandler={faqListHandler}
      />
      <EditFAQModel
        setEditModal={setEditModal}
        editModal={editModal}
        faqListHandler={faqListHandler}
        inputData={inputData}
        types={types}
        setInputData={setInputData}
      />
      {/* Description Modal */}

      {descriptionModal && (
        <CustomModal
          className={"add_model"}
          show={descriptionModal}
          handleClose={() => {
            setDescriptionModal(false);
          }}
        >
          <h3>Description</h3>
          <h7>{description}</h7>
        </CustomModal>
      )}
    </>
  );
};

export default FAQManagement;
